module.exports = __webpack_public_path__ + "img/banner-bar_icon2.366908ad.png";